import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React, { CSSProperties } from 'react';
import { IStyle } from 'Styles';
import './styles.scss';
interface CheckBoxProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  mainContainerStyle?: CSSProperties;
  labelStyle?: CSSProperties;
  checkboxIconClass?: string;
}

function CustomCheckBox(props: CheckBoxProps) {
  const {
    checked,
    disabled = false,
    label,
    mainContainerStyle,
    labelStyle,
    onClick,
    checkboxIconClass,
    onChange,
    ...rest
  } = props;

  const changeHandler = (e) => {
    if (!disabled && onChange) {
      onChange(e);
    }
  };

  const clickHandler = (e) => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  return (
    <div id='customcheckbox-wrapper'
      {...(label && { style: { ...styles.mainContainer, ...mainContainerStyle } })}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <label id='customcheckbox-label' className="custom-checkbox-main-container">
        <input
          id='customcheckbox-input'
          type="checkbox"
          className="custom-checkbox-input"
          onChange={changeHandler}
          onClick={clickHandler}
          {...rest}
        />
        <RMSvgIcon
          id='customcheckbox-svg-checkmark-icon'
          name="checkMark"
          fill={!checked && disabled ? 'transparent' : 'white'}
          className={`checkbox ${checked && 'checkbox--active'}
           ${disabled && 'checkbox--disable'} ${checkboxIconClass}`}
        />
      </label>
      {label && (
        <div id={`customcheckbox-${label}`} style={labelStyle ? labelStyle : styles.LabelTextStyle}>{label}</div>
      )}
    </div>
  );
}

const styles: IStyle = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  LabelTextStyle: {
    fontFamily: 'Arial',
    fontWeight: 400,
    fontSize: 18,
    color: '#4F4F4F',
    marginLeft: '0.75rem',
  },
};
export default CustomCheckBox;
